module.exports = __webpack_public_path__ + "img/benefit_card_image_8.79f45239.png";